import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const SearchRelations = withSuspense(lazy(() => import('./relation-search')));
export default SearchRelations;
